import React from 'react';
import { Navigate } from 'react-router-dom';
import useStore from '../store/index';
import { isAdminUser } from '../utils/access';

/** Restricts a route to admin users only. */
const AdminRoute = ({ children }) => {
  const { user, accessToken } = useStore();

  if (!accessToken) return null;

  if (!isAdminUser(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
